export default function UHeaderLeftMenu(props) {
  return props.children
}
